import * as React from 'react';
import Box from '@mui/joy/Box';
import Drawer from '@mui/joy/Drawer';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import { Card, CardContent, Chip, CircularProgress, Divider, List, ListItem, Stack, Typography } from '@mui/joy';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { extractTime, formatDate, formatDuration } from '../utils';
import { viewItinary } from '../../server/api';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import PersonIcon from '@mui/icons-material/Person'
import { removeLastWord } from '../../utils/HelperFunctions';


function formatDateOrTime(dateString, type) {
    // Check the type and return either the date or time
    if (type === "date") {
        return dateString.split('T')[0]; // Extract date in "YYYY-MM-DD" format
    } else if (type === "time") {
        return dateString.split('T')[1]; // Extract time in "HH:mm:ss" format
    } else {
        return "N/A";
    }
}


const Header = ({ setState }) => {
    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
                <Typography level="h1">Details</Typography>
                <CloseIcon onClick={() => setState(false)} sx={{ cursor: 'pointer', fontSize: '30px' }} />
            </Box>
        </>
    )
}

const FlightTab = ({ flight, isAmadus, isHitit }) => {
    console.log(flight)
    return (
        <>
            {flight && flight.length > 0 ? flight?.map((item, index) => (
                <Box key={index} sx={{ border: '1px solid black', borderRadius: '20px', marginTop: index !== 0 && '10px', padding: '10px' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
                        <Box>
                            <Typography level="h4">
                                {isHitit ? item?.departureLocation : isAmadus ? item?.departure?.iataCode : item?.fromAirportCode}
                            </Typography>
                            {!isHitit && !isAmadus && (
                                <>
                                    <Typography sx={{ fontSize: '11px' }}>{isAmadus ? item?.departure?.iataCode : item?.fromAirport?.name}</Typography>
                                    <Typography sx={{ fontSize: '11px' }}>{isAmadus ? item?.departure?.iataCode : item?.fromAirport?.city}</Typography>
                                    <Typography sx={{ fontSize: '11px' }}>{isAmadus ? item?.departure?.iataCode : item?.fromAirport?.country}</Typography>
                                </>
                            )}
                            <Typography level="title-sm" color="neutral" sx={{ mt: 2 }}>
                                {isHitit ? item?.departureTime?.split('T')?.[0] : isAmadus ? formatDateOrTime(item?.departure?.at, "date") : item?.departureDate}
                            </Typography>
                        </Box>

                        <Box>
                            <ArrowForwardIcon sx={{ fontSize: '30px' }} />
                        </Box>

                        <Box>
                            <Typography level="h4" sx={{ textAlign: 'right' }}>
                                {isHitit ? item?.arrivalLocation : isAmadus ? item?.arrival?.iataCode : item?.toAirportCode}
                            </Typography>
                            {!isHitit && !isAmadus && (
                                <>
                                    <Typography level="body1" sx={{ textAlign: 'right', fontSize: '11px' }}>{isAmadus ? item?.arrival?.iataCode : item?.toAirport?.name}</Typography>
                                    <Typography level="body1" sx={{ textAlign: 'right', fontSize: '11px' }}>{isAmadus ? item?.arrival?.iataCode : item?.toAirport?.city}</Typography>
                                    <Typography level="body1" sx={{ textAlign: 'right', fontSize: '11px' }}>{isAmadus ? item?.arrival?.iataCode : item?.toAirport?.country}</Typography>
                                </>
                            )}
                            <Typography level="title-sm" color="neutral" sx={{ textAlign: 'right', mt: 2 }}>
                                {isHitit ? item?.arrivalTime?.split('T')?.[0] : isAmadus ? formatDateOrTime(item?.arrival?.at, "date") : item?.arrivalDate}
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
                        <Box>
                            <Typography level="h3">
                                {isHitit ? item?.departureTime?.split('T')?.[1]?.substring(0, 5) : isAmadus ? formatDateOrTime(item?.departure?.at, "time") : item?.departureTime}
                            </Typography>
                        </Box>

                        {/* <Box>
                            <Typography level="title-md">{formatDuration(item?.elapsedTime)}</Typography>
                        </Box> */}

                        <Box>
                            <Typography level="h3" sx={{ textAlign: 'right' }}>
                                {isHitit ? item?.arrivalTime?.split('T')?.[1]?.substring(0, 5) : isAmadus ? formatDateOrTime(item?.arrival?.at, "time") : item?.arrivalTime}
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
                        <Box>
                            <Typography level="title-sm">Airline</Typography>
                            <Typography level="title-lg">
                                {isHitit ? item?.marketingCarrier : isAmadus ? item?.carrierCode : item?.airlineName}
                            </Typography>
                        </Box>

                        <Box>
                            <Typography level="title-sm" sx={{ textAlign: 'right' }}>Flight Number</Typography>
                            <Typography level="title-lg" sx={{ textAlign: 'right' }}>
                                {isHitit
                                    ? `${item?.marketingCarrier}-${item?.marketingFlightNumber}`
                                    : isAmadus
                                        ? `${item?.carrierCode}-${item?.number}`
                                        : `${item?.airlineCode}-${item?.flightNumber}`}
                            </Typography>
                        </Box>
                    </Box>

                    {isHitit && item?.cabin?.name && (
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
                            <Box>
                                <Typography level="title-sm">Cabin Class</Typography>
                                <Typography level="title-lg">{item?.cabin?.name}</Typography>
                            </Box>
                        </Box>
                    )}


                    {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
                        <Box>
                            <Typography level="title-sm">Aircraft Type</Typography>
                            <Typography level="title-lg">{isAmadus ? "N/A" : item?.aircraftTypeName ? item?.aircraftTypeName : 'N/A'}</Typography>
                        </Box>

                        <Box>

                            <Typography level="title-sm" sx={{ textAlign: 'right' }}>Cabin</Typography>
                            <Typography level="title-lg" sx={{ textAlign: 'right' }}>{isAmadus ? item?.co2Emissions?.[0]?.cabin : item?.cabinTypeName ? item?.cabinTypeName : "N/A"}</Typography>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
                        <Box>
                            <Typography level="title-sm">Terminal</Typography>
                            <Typography level="title-lg">{isAmadus ? item?.arrival?.terminal : item?.departureTerminalName ? item?.departureTerminalName : "N/A"}</Typography>
                        </Box>

                        <Box>

                            <Typography level="title-sm" sx={{ textAlign: 'right' }}>Aircraft Code</Typography>
                            <Typography level="title-lg" sx={{ textAlign: 'right' }}>{isAmadus ? item?.aircraft?.code : item?.aircraftTypeCode ? item?.aircraftTypeCode : "N/A"}</Typography>
                        </Box>
                    </Box> */}
                </Box>
            )) : (
                <Box sx={{ height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography level='h1'>No Data Available</Typography>
                </Box>
            )}
        </>
    )
}

const TravelerDetail = ({ travelers, isAmadus, isHitit, isSabre }) => {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: 2,
            }}
        >
            {travelers ? travelers.map((traveler, index) => (
                <Card key={index} variant="outlined">
                    <CardContent>
                        <Typography level="title-lg">
                            {isAmadus
                                ? `${traveler?.name?.firstName || ""} ${traveler?.name?.lastName || ""}`.trim()
                                : (isHitit || isSabre)
                                    ? (traveler.givenName || "")
                                    : `${removeLastWord(traveler.givenName || "")} ${traveler.surname || ""}`.trim()
                            }
                        </Typography>
                        <Chip
                            size="sm"
                            variant="soft"
                            color={traveler?.identityDocuments?.[0]?.gender === 'MALE' || traveler?.gender === "MALE" ? 'primary' : traveler?.identityDocuments?.[0]?.gender === 'FEMALE' || traveler?.gender === "FEMALE" ? 'warning' : 'success'}
                            sx={{ mt: 1, mb: 2 }}
                        >
                            {isAmadus ? traveler?.gender : traveler?.identityDocuments?.[0]?.gender}
                        </Chip>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <CalendarTodayIcon sx={{ fontSize: 'small' }} />
                                <Typography level="body-sm">
                                    Born: {isAmadus ? traveler?.dateOfBirth : traveler?.identityDocuments?.[0]?.birthDate}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <CreditCardIcon sx={{ fontSize: 'small' }} />
                                <Typography level="body-sm">{isAmadus ? traveler?.documents?.[0]?.documentType : traveler?.identityDocuments?.[0]?.documentType}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <PersonIcon sx={{ fontSize: 'small' }} />
                                <Typography level="body-sm">NO.: {isAmadus ? traveler?.documents?.[0]?.number : traveler?.identityDocuments?.[0]?.documentNumber}</Typography>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            )) : (
                <Box sx={{ height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography level='h1'>No Data Available</Typography>
                </Box>
            )}
        </Box>
    )
}

export default function ViewBooking({ state, setState, toggleDrawer, api, id }) {

    const [resData, setResData] = React.useState(null)
    const [isLoading, setIsLoading] = React.useState(false)

    const viewFlightDetail = () => {
        setIsLoading(true); // Start loading indicator
        setResData(null);   // Clear previous data

        const urlParam = (api === "amadeus" || api === "amadus") ? "flights" : api;
        console.log("[ViewBooking] Calling viewItinary with id:", id, "url:", urlParam, "api:", api);

        // Make the API call
        viewItinary(id, urlParam)
            .then((res) => {
                console.log("[ViewBooking] Full API response:", res);
                console.log("[ViewBooking] res.body:", res?.body);
                console.log("[ViewBooking] res.status:", res?.status, "res.code:", res?.code);

                const isFail = res?.status === "fail" || (res?.code && res.code >= 400);
                if (isFail) {
                    console.error("[ViewBooking] Error response:", res);
                    setResData(null);
                } else {
                    if (api?.toLowerCase() === "hitit") {
                        // Hitit returns { code:200, message:"...", body: { departure:[...], ... } }
                        const hitData = res?.body || res?.result || res;
                        console.log("[ViewBooking] Hitit data:", hitData);
                        setResData(hitData);
                    } else {
                        const data = res?.result?.data || res?.result || null;
                        console.log("[ViewBooking] Non-hitit data:", data);
                        setResData(data);
                    }
                }
            })
            .catch((error) => {
                console.error("[ViewBooking] API call failed:", error);
                setResData(null);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };


    React.useEffect(() => {
        if (id) {
            viewFlightDetail();
        }
    }, [id, api])

    return (
        <React.Fragment>
            <Drawer
                // key={anchor}
                anchor="right"
                open={state}
                onClose={toggleDrawer(false)}
                size="lg"
            >
                <Header {...{ setState }} />
                {isLoading ? (
                    <Box sx={{ height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress
                            color="primary"
                            size="md"
                            value={40}
                        />
                    </Box>
                ) : !resData ? (
                    <Box sx={{ height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography level='h1'>No Data Available</Typography>
                    </Box>
                ) : (
                    <Tabs aria-label="Basic tabs" defaultValue={0}>
                        <TabList>
                            <Tab>Flight</Tab>
                            <Tab>Traveler</Tab>
                        </TabList>
                        <TabPanel value={0}>
                            {resData?.type === "flight-order" ? (
                                resData?.flightOffers?.[0]?.itineraries?.map((itinerary, itIndex) => (
                                    <Box key={itIndex} sx={{ mb: 2 }}>
                                        <Typography level="title-sm" sx={{ mb: 1, color: 'primary.main', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                            Leg {itIndex + 1}
                                        </Typography>
                                        <FlightTab
                                            flight={itinerary.segments}
                                            isAmadus={true}
                                            isHitit={false}
                                        />
                                        {itIndex < (resData?.flightOffers?.[0]?.itineraries?.length - 1) && <Divider sx={{ my: 2 }} />}
                                    </Box>
                                ))
                            ) : (
                                <FlightTab
                                    flight={
                                        api?.toLowerCase() === 'hitit'
                                            ? (resData?.departure?.length > 0 ? resData?.departure : null)
                                            : resData?.flights
                                    }
                                    isAmadus={api?.toLowerCase() === 'amadeus' || api?.toLowerCase() === 'amadus'}
                                    isHitit={api?.toLowerCase() === 'hitit'}
                                />
                            )}
                        </TabPanel>
                        <TabPanel value={1}>
                            <TravelerDetail {...{ travelers: resData?.travelers, isAmadus: resData?.type === "flight-order", isHitit: api?.toLowerCase() === "hitit", isSabre: api?.toLowerCase() === "sabre" }} />
                        </TabPanel>
                    </Tabs>
                )}
            </Drawer>
        </React.Fragment>
    );
}
